import { render } from "./emailCheckPage.vue?vue&type=template&id=1490d94a&scoped=true"
import script from "./emailCheckPage.vue?vue&type=script&lang=js"
export * from "./emailCheckPage.vue?vue&type=script&lang=js"

import "./emailCheckPage.vue?vue&type=style&index=0&id=1490d94a&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1490d94a"]])

export default __exports__